angular.module('bribac.components.ibacBatteryDetails', [
  'bribac.translations'
])

  .component('ibacBatteryDetails', {
    templateUrl: 'ibac-battery-details-component.html',
    bindings: {
      ibac: '<'
    }
  })
